<div>
    <div class="modal-header">
        <h3>Select correct record</h3>
    </div>
    <div class="modal-body">
        <table class="table table-striped panel panel-default">
            <thead>
            <th></th>
            <th>Name</th>
            <th>Village</th>
            </thead>
            <tbody>
            <tr *ngFor="let site of selectedSites">
                <td><input name="select" [(ngModel)]="correctSite" type="radio" [value]="site"></td>
                <td>{{ site.name }}</td>
                <td>{{ site.village | display:sitesService.meta.fields.village.choices }}</td>
            </tr>
            </tbody>
        </table>

    </div>
    <div class="modal-footer">
        <button class="btn btn-warning" (click)="cancel()">Cancel</button>
        <button class="btn primary-btn" (click)="submit()">Submit</button>
    </div>
</div>
